import React, { useRef } from "react";
import TestimonyImage1 from "../assets/VisibilityAudit/VisibilityAudit4.png";
import TestimonyImage2 from "../assets/VisibilityAudit/VisibilityAudit2.png";
import TestimonyImage4 from "../assets/VisibilityAudit/VisibilityAudit11.png";
import TestimonyImage5 from "../assets/VisibilityAudit/VisibilityAudit5.png";
import TestimonyImage6 from "../assets/VisibilityAudit/VisibilityAudit6.png";
import TestimonyImage7 from "../assets/VisibilityAudit/VisibilityAudit7.png";
import TestimonyImage8 from "../assets/VisibilityAudit/VisibilityAudit8.png";
import TestimonyImage9 from "../assets/VisibilityAudit/VisibilityAudit9.png";
import TestimonyImage10 from "../assets/VisibilityAudit/VisibilityAudit10.png";
import TestimonyImage11 from "../assets/VisibilityAudit/VisibilityAudit.png";
import TestimonyImage12 from "../assets/VisibilityAudit/VisibilityAudit12.png"


function PastWork() {
  const containerRef = useRef(null);

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  // Array of testimonials with image sources
  const testimonials = [
    { image: TestimonyImage12, name: "James Smith", role: "Marketing Director" },
    { image: TestimonyImage1, name: "David James", role: "CEO/Chairman" },
    { image: TestimonyImage2, name: "Sarah Lee", role: "Founder" },
    { image: TestimonyImage4, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage5, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage6, name: "Linda Green", role: "COO" },
    { image: TestimonyImage7, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage8, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage9, name: "Linda Green", role: "COO" },
    { image: TestimonyImage10, name: "Linda Green", role: "COO" },
    { image: TestimonyImage11, name: "Linda Green", role: "COO" },
  ];

  return (
    <main className="relative h-auto w-screen overflow-x-hidden bg-[#F4F3E1]">
      <title>
        SEO Visibility Audit: Boost Website Traffic & Conversions | Her Grwoth Co. | Boost Your Website's Visibility: SEO Audit Package
      </title>
      <meta
        name="description"
        content="Identify website issues with our SEO Visibility Audit. We analyze speed, SEO, mobile & UX, providing actionable insights to boost traffic and conversions. Book your audit today!"
      />
      <meta
        name="keywords"
        content="seo lawyer, seo services for lawyers, lawyer seo companies, lawyer seo services, lawyer seo, seo for lawyers, seo firm., search engine optimization for attorneys, seo marketing for law firms, attorney search engine optimization, search engine optimization lawyers, legal firm seo, seo law fellowship, lawyer web marketing, seo service for lawyers, marketing agency for law firm, website marketing for law firms, web site marketing for attorney, law firm seo, legal seo services, attorneys seo, attorney seo, seo services for law firms, best law firm seo, lawyer seo company, lawyer seo experts, attorney seo company, lawyer seo, best seo providers, best companies for seo, best company for seo, seo best company, best seo companies, best-seo-services, seo pricing packages, best company for seo, best companies for seo, seo austin, seo austin texas, women web designers, women in web design"
      />
      <section>

        {/* Our Projects */}

        <section className="bg-[#F7F3F2]">
          <div className="bg-[#F7F3F2] h-auto">
            <h2 className="text-center text-2xl font-meduim md:text-4xl text-black pt-16 mb-16 uppercase">
              Featured Projects{" "}
              
            </h2>

            {/* Left Arrow Button */}
            <button
              className="absolute top-1/2 left-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollLeft}
            >
              {/* Left Arrow SVG */}
              {/* <svg
                width="50"
                height="50"
                viewBox="0 0 72 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="71"
                  height="71"
                  rx="35.5"
                  stroke="#000000" // White color for the background circle stroke
                />
                <path
                  d="M44 35.5H31.83L37.42 29.91L36 28.5L28 36.5L36 44.5L37.41 43.09L31.83 37.5H44V35.5Z"
                  fill="#000000" // White color for the arrow itself
                />
              </svg> */}
            </button>

            <div className="relative flex items-center justify-center">
              <div
                ref={containerRef}
                className="flex overflow-x-auto gap-28 py-6 scroll-smooth scroll-m-0  max-w-[1040px] w-full" // Limit the width to 4 items
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="min-w-[650px]">
                  <a href={testimonial.link}>
                    <img
                      className="object-cover w-full h-auto"
                      src={testimonial.image} // Display the image from assets
                      alt={`Testimonial ${index + 1}`}
                    />
                    </a>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Arrow Button */}
            <button
              className="absolute top-1/2 right-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollRight}
            >
              {/* Right Arrow SVG */}
              {/* <svg
              width="50"
              height="50"
              viewBox="0 0 72 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="1"
                width="71"
                height="71"
                rx="35.5"
                stroke="#000000" // White color for the background circle stroke
              />
              <path
                d="M36 28.5L34.59 29.91L40.17 35.5H28V37.5H40.17L34.59 43.09L36 44.5L44 36.5L36 28.5Z"
                fill="#000000" // White color for the arrow itself
              />
            </svg> */}
            </button>
            
          </div>
          <div className="flex flex-col items-center justify-center mt-4">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
               BROWSE MY WORK →
              </a>
            </div>
          
        </section>
      </section>
    </main>
  );
}

export default PastWork;
